import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const DEMO_MAILTO = 'mailto:demorequest@prmassist.com?subject=Demo%20Request';

const RequestDemo = () => {
    const history = useHistory();

    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'demo_request_click' });
        window.location.href = DEMO_MAILTO;
        history.replace('/');
    }, [history]);

    return null;
};

export default RequestDemo;
